import React from 'react';
import { Menu, MenuItem, MenuList, Button } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { ACTIVITY_CALENDAR_ACTIONS } from '../../../../constants/ActivityCalendarConst';

const ActivityKebabMenu = ({ activityData, handleActions, setSuppressViewClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setSuppressViewClick(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (actionName) => {
    handleActions(activityData, actionName);
    handleClose();
  };

  return (
    <>
      <Button
        aria-controls='simple-menu'
        aria-haspopup='true'
        className='showpopupInner'
        onClick={(e) => {
          e.stopPropagation();
          handleClick(e);
        }}
        disableRipple
      >
        <MoreHoriz className='showpopupInner' />
      </Button>
      <Menu
        className='shadow sideMenu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuList>
          {ACTIVITY_CALENDAR_ACTIONS?.map((action) => (
            <MenuItem
              key={action.id}
              className='pe-4'
              onClick={(e) => {
                e.stopPropagation();
                handleActionClick(action?.name);
              }}
            >
              {action.getIcon ? action?.getIcon(activityData?.isActive) : action?.icon}
              {action?.name === 'Deactivate' && !activityData?.isActive ? 'Activate' : action?.name}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </>
  );
};

ActivityKebabMenu.propTypes = {
  activityData: PropTypes.object.isRequired,
  handleActions: PropTypes.func.isRequired,
};

export default ActivityKebabMenu;
